import React, { useState, useEffect } from 'react'
import API from '../../utils/API'
import './Password.css'
import { connect } from 'react-redux'
import ModalPasswordInput from '../../components/Modals/ModalInputs/ModalPasswordInput'

function Activate(props) {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passcode, setPasscode] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [passwordConfirmValid, setPasswordConfirmValid] = useState(false);
  const [minimumLength, setMinimumLength] = useState('');
  const [error, setError] = useState('');
  const user = props.user
  // Global Policy IDs
  const policyID = {
    password: 'd53bcda0-a108-4b18-b066-1b04bdfbe200',
    twoFactorAuth: '8eef3696-e258-40e7-a611-bafa2bb42c71',
  }

  useEffect(() => {
    getPasswordPolicy(user.email);
  }, [])
  // Get passcode and email from the URL generated by reset email link.

  function getPasswordPolicy(email) {
    if(!email){
        window.location='/login'
    }
    API.getEmailGlobalPolicies(email)
    .then(({ data }) => {
      // If password length policy exists then we set minimum length constraint
      let passwordSetting = data.find(setting => setting.id === policyID.password);
      if(passwordSetting) {
        setMinimumLength(passwordSetting.settings.minimumLength);
      }
    })
    .catch(err => {
      console.error(err);
    });
  }

  function handleSubmit() {
    setSubmitted(true);
    if(newPassword && confirmPassword) {
      if(newPassword !== confirmPassword) {
        setPasswordValid(false);
        setError("Passwords do not match.")
        return; 
      }

      if(newPassword.length < minimumLength) {
        setPasswordValid(false);
        setError("Password must be " + minimumLength +  " characters.");
        return;
      }

      API.activateUser(newPassword).then((res)=>{
        window.location ='/login'
      }).catch(err => {
        setError(err.message);
      })

    } else {
      setError("Missing input in password field.");
      return;
    }
  }

  return (
    <div className='password container py-5 h-100'>
      <div className='row d-flex justify-content-center p-3'>
        <div className='col-xl-4'>
          <form className="needs-validation">
            <div className='header text-center mb-4'>
              <h2>Change Password</h2>
            </div>
            <div className='card'>
                <div className='mb-3 text-secondary'>
                    Password must be reset the first time a user logs in.
                </div>
              <div className='form-outline mb-3'>
                <label className='form-label' htmlFor='newPassword'>New Password</label>
                <ModalPasswordInput 
                  onChange={(e) => setNewPassword(e.target.value)} 
                  value={newPassword} 
                  name='newPassword' 
                  isSubmitted={submitted}
                  isValid={passwordValid}
                  className='form-control rounded-1' required />
                {minimumLength ? 
                  <div>
                    <span className="passReq text-secondary">Password requirements: </span>
                    <ul>
                      <li className={`passReq ${newPassword.length < minimumLength ? "text-danger" : "text-success"}`}>
                        Must be at least {minimumLength} characters.
                      </li>
                      <li className={`passReq ${(newPassword === confirmPassword && newPassword.length > 0) ? "text-success" : "text-danger"}`}>
                        Passwords must match.
                      </li>
                    </ul>
                  </div>
                  :
                  null
                }
              </div>
              <div className='form-outline mb-4'>
                <label className='form-label' htmlFor='confirmPassword'>Confirm Password</label>
                <ModalPasswordInput 
                  onChange={(e) => setConfirmPassword(e.target.value)} 
                  value={confirmPassword} 
                  name='confirmPassword' 
                  isSubmitted={submitted}
                  isValid={passwordValid}
                  className='form-control rounded-1' />
              </div>
              {error ? <p className='error'>ERROR: {error}</p> : null}
              <button type='button' className='btn btn-primary btn-block mb-1' onClick={handleSubmit}>Submit</button>
              <div className='login-btn row text-center'>
                <a href='../login'>Back to log in</a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}


const mapStateToProps = (state) => ({
    user: state.user
});
  
export default connect(mapStateToProps)(Activate);
  